import { ISolicitudAutorizarAccesoModel } from "../interfaces/solicitud/ISolicitudAutorizarAccesoModel";


export class SolicitudAutorizarAccesoModel implements ISolicitudAutorizarAccesoModel {
    listaSolicitudes: SolicitudAccesoResultadoModel[];
    constructor(){
        this.listaSolicitudes = new Array<SolicitudAccesoResultadoModel>();
    }
}
export class SolicitudAccesoResultadoModel{
    idSolicitud: number;
    autorizado: boolean;
    rechazado: boolean;

    constructor(){
        this.idSolicitud = 0;
        this.autorizado = false;
        this.rechazado = false;        
    }
}